'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

const React = require('react');
const React__default = _interopDefault(React);
const tslib = require('tslib');
const useProps = require('../html/use-props.js');
const buildAttrs = require('./utils/build-attrs.js');
const createRenderState = require('./utils/create-render-state.js');

function useSVGProps(props, visualState) {
  var visualProps = React.useMemo(function () {
    var state = createRenderState.createSvgRenderState();
    buildAttrs.buildSVGAttrs(state, visualState, undefined, undefined, {
      enableHardwareAcceleration: false
    }, props.transformTemplate);
    return tslib.__assign(tslib.__assign({}, state.attrs), {
      style: tslib.__assign({}, state.style)
    });
  }, [visualState]);
  if (props.style) {
    var rawStyles = {};
    useProps.copyRawValuesOnly(rawStyles, props.style, props);
    visualProps.style = tslib.__assign(tslib.__assign({}, rawStyles), visualProps.style);
  }
  return visualProps;
}

exports.useSVGProps = useSVGProps;
